import { render } from "./LegacyFilterModal.vue?vue&type=template&id=566118a4"
import script from "./LegacyFilterModal.vue?vue&type=script&lang=js"
export * from "./LegacyFilterModal.vue?vue&type=script&lang=js"
script.render = render

export default script